"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEAD_CATEGORY_KEY = 'base';
exports.HEAD_PARENT_COMPONENT_KEY = 'table';
exports.HEAD_COMPONENT_KEY = 'head';